import React from 'react';
import './LandingPage.css';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <div className="text-2xl font-bold text-indigo-600">
                📚 HWK Studio
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200"
              >
                Fazer Login
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 animate-fade-in">
            Gerencie tarefas escolares
            <span className="text-indigo-600 block">de forma inteligente</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Uma plataforma completa que conecta professores, alunos e responsáveis 
            para tornar o acompanhamento escolar mais eficiente e organizado.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/login"
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Começar Agora
            </Link>
            <button
              onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white hover:bg-gray-50 text-indigo-600 px-8 py-4 rounded-lg text-lg font-semibold border-2 border-indigo-600 transition-colors duration-200"
            >
              Saiba Mais
            </button>
          </div>
        </div>

        {/* Features Section */}
        <section id="features" className="py-16">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Para Professores */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 feature-card">
              <div className="text-4xl mb-4">👨‍🏫</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Para Professores</h3>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Criação de tarefas intuitiva
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Gestão de alunos simplificada
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Correção e feedback automático
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Relatórios de desempenho
                </li>
              </ul>
            </div>

            {/* Para Alunos */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 feature-card">
              <div className="text-4xl mb-4">🎓</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Para Alunos</h3>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Acesso fácil às tarefas
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Submissão online segura
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Acompanhamento de progresso
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Notificações de prazos
                </li>
              </ul>
            </div>

            {/* Para Responsáveis */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 feature-card">
              <div className="text-4xl mb-4">👨‍👩‍👧‍👦</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Para Responsáveis</h3>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Acompanhamento em tempo real
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Análises detalhadas
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Comunicação direta
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Relatórios de desempenho
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-indigo-600 rounded-2xl text-white text-center my-16">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="text-4xl font-bold mb-2">100%</div>
              <div className="text-indigo-200">Digital e Seguro</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">24/7</div>
              <div className="text-indigo-200">Acesso Disponível</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">∞</div>
              <div className="text-indigo-200">Possibilidades</div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center py-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Pronto para revolucionar a educação?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Junte-se a milhares de educadores que já estão transformando 
            a experiência de aprendizado com nossa plataforma.
          </p>
          <Link
            to="/login"
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-10 py-4 rounded-lg text-xl font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl inline-block"
          >
            Começar Gratuitamente
          </Link>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-2xl font-bold text-indigo-400 mb-4">
            📚 HWK Studio
          </div>
          <p className="text-gray-400 mb-4">
            Transformando a educação através da tecnologia
          </p>
          <div className="flex justify-center space-x-6 text-gray-400">
            <span>© 2024 HWK Studio. Todos os direitos reservados.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 